import { CompareFn } from './types'

export const compareUnknown: CompareFn<unknown> = (
  a: unknown,
  b: unknown,
): boolean => {
  return JSON.stringify(a).localeCompare(JSON.stringify(b)) === 0
}
